function initCbMegaMenu(root) {
  const scope = root || document;
  const megaItems = scope.querySelectorAll('[data-cb-mega-item]');
  let activeItem = null;
  let closeTimer = null;

  function openItem(item) {
    if (closeTimer) window.clearTimeout(closeTimer);
    if (activeItem && activeItem !== item) {
      activeItem.classList.remove('cb-mega-nav__item--active');
      const oldTrigger = activeItem.querySelector('[data-cb-mega-trigger]');
      if (oldTrigger) oldTrigger.setAttribute('aria-expanded', 'false');
    }
    activeItem = item;
    activeItem.classList.add('cb-mega-nav__item--active');
    const trigger = activeItem.querySelector('[data-cb-mega-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function closeActive(delay = 120) {
    if (!activeItem) return;
    closeTimer = window.setTimeout(() => {
      if (!activeItem) return;
      const trigger = activeItem.querySelector('[data-cb-mega-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      activeItem.classList.remove('cb-mega-nav__item--active');
      activeItem = null;
    }, delay);
  }

  function updatePromoCard(card, data) {
    if (!card || !data || !data.image) return;

    const img = card.querySelector('.cb-mega-nav__promo-image');
    const title = card.querySelector('[data-cb-promo-title]');

    if (!img) return;

    card.classList.remove('is-active');
    card.classList.add('is-switching');

    window.setTimeout(() => {
      img.src = data.image;
      img.srcset = '';
      if (title) title.textContent = data.title || '';
      if (data.href) card.setAttribute('href', data.href);

      card.classList.remove('is-switching');
      card.classList.add('is-active');
    }, 120);
  }

  function setupPromoHover(item) {
    if (item.dataset.cbPromoBound === 'true') return;
    item.dataset.cbPromoBound = 'true';

    const panel = item.querySelector('[data-cb-mega-panel]');
    if (!panel) return;

    const stage = panel.querySelector('[data-cb-promo-stage]');
    if (!stage) return;

    const links = panel.querySelectorAll('[data-cb-image-trigger]');
    const layout = stage.getAttribute('data-cb-layout');
    const card1 = stage.querySelector('[data-cb-promo-card="1"]');
    const card2 = stage.querySelector('[data-cb-promo-card="2"]');

    links.forEach((link) => {
      link.addEventListener('mouseenter', function () {
        const image1 = link.getAttribute('data-image-1');
        const image2 = link.getAttribute('data-image-2');
        const title1 = link.getAttribute('data-image-1-title') || link.textContent.trim();
        const title2 = link.getAttribute('data-image-2-title') || link.textContent.trim();
        const href = link.getAttribute('href') || '#';

        if (!image1) return;

        updatePromoCard(card1, {
          image: image1,
          title: title1,
          href: href
        });

        if (layout === 'one_column_two_images' && card2) {
          updatePromoCard(card2, {
            image: image2 || image1,
            title: title2,
            href: href
          });
        }
      });
    });
  }

  megaItems.forEach((item) => {
    if (item.dataset.cbMegaBound !== 'true') {
      item.dataset.cbMegaBound = 'true';

      item.addEventListener('mouseenter', () => openItem(item));
      item.addEventListener('mouseleave', () => closeActive(140));
      item.addEventListener('focusin', () => openItem(item));
      item.addEventListener('focusout', () => closeActive(140));
    }

    setupPromoHover(item);
  });

  const mobileTriggers = scope.querySelectorAll('[data-cb-mobile-accordion-trigger]');

  mobileTriggers.forEach((trigger) => {
    if (trigger.dataset.cbAccordionBound === 'true') return;
    trigger.dataset.cbAccordionBound = 'true';

    trigger.addEventListener('click', function () {
      const item = trigger.closest('.cb-mobile-menu__item');
      const panel = item.querySelector('.cb-mobile-menu__panel');
      const isOpen = item.classList.contains('is-open');

      scope.querySelectorAll('.cb-mobile-menu__item.is-open').forEach((openItem) => {
        openItem.classList.remove('is-open');
        const openTrigger = openItem.querySelector('[data-cb-mobile-accordion-trigger]');
        const openPanel = openItem.querySelector('.cb-mobile-menu__panel');
        if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
        if (openPanel) openPanel.hidden = true;
      });

      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        if (panel) panel.hidden = false;
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initCbMegaMenu(document);
});

document.addEventListener('shopify:section:load', function (event) {
  initCbMegaMenu(event.target);
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    document.querySelectorAll('[data-cb-mega-item].cb-mega-nav__item--active').forEach((item) => {
      item.classList.remove('cb-mega-nav__item--active');
      const trigger = item.querySelector('[data-cb-mega-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }
});